import PropTypes from 'prop-types';
import React from 'react';
import { ConsentTypeChoice } from '@unite-us/app-components';
import { CONSENT_OPTIONS } from 'src/components/InformedConsent/constants';
import { env } from 'src/config/env';
import ConsentFileUpload from './ConsentFileUpload';
import DownloadConsentFormLink from './DownloadConsentFormLink';
import ViewVerbalConsentScriptLink from './ViewVerbalConsentScriptLink';
import NHDocumentUploadSection from './NHDocumentUploadSection';

const getDocumentDropzone = (hasPlatformConsent, fields, sentReferrals, isNHConsentProvider) => {
  if (isNHConsentProvider) {
    return (
      <div className="flex flex-col mb-8 space-y-6">
        <div className="border-b border-solid border-light-border-blue" />
        {!hasPlatformConsent && (
          <>
            <div className="flex justify-between">
              <span className={fields[CONSENT_OPTIONS.DOCUMENT]?.invalid ? 'text-red' : ''}>
                Unite Us Consent <span className="text-red">*Required</span>
              </span>
              <DownloadConsentFormLink
                text="Download Unite Us consent form"
                url={env.CONSENT_DOWNLOAD_URL}
              />
            </div>
            <ConsentFileUpload name="Consent" type={CONSENT_OPTIONS.DOCUMENT} />
          </>
        )}
        <NHDocumentUploadSection fields={fields} sentReferrals={sentReferrals} />
      </div>
    );
  }

  return (
    <div className="flex flex-col mb-8 space-y-6">
      <div className="flex justify-between">
        <span>Unite Us Consent</span>
        <DownloadConsentFormLink
          text="Download Consent Form"
          url={env.CONSENT_DOWNLOAD_URL}
        />
      </div>
      <ConsentFileUpload name="Consent" type={CONSENT_OPTIONS.DOCUMENT} />
    </div>
  );
};

const PaperAndVerbalConsentSection = ({
  selectConsentType,
  selectedConsentType,
  hasPlatformConsent,
  fields,
  sentReferrals,
  isNHConsentProvider,
}) => (
  <div className="consent-type-choices-group paper-and-verbal-consent">
    <h3 className="consent-type-choices-group__title">
      Paper And Verbal Consent
    </h3>
    <div className="flex flex-col gap-2">
      <ConsentTypeChoice
        type={CONSENT_OPTIONS.DOCUMENT}
        label="Upload signed paper form"
        onSelect={selectConsentType}
        selectedType={selectedConsentType}
        dropzone={getDocumentDropzone(hasPlatformConsent, fields, sentReferrals, isNHConsentProvider)}
      />

      {!isNHConsentProvider && (
        <ConsentTypeChoice
          type={CONSENT_OPTIONS.AUDIO}
          label="Upload audio file (client consented verbally)"
          onSelect={selectConsentType}
          selectedType={selectedConsentType}
          dropzone={(
            <ConsentFileUpload name="Consent" type={CONSENT_OPTIONS.AUDIO} />
          )}
        >
          <ViewVerbalConsentScriptLink />
        </ConsentTypeChoice>
      )}
    </div>
  </div>
);

PaperAndVerbalConsentSection.propTypes = {
  selectConsentType: PropTypes.func.isRequired,
  selectedConsentType: PropTypes.string.isRequired,
  hasPlatformConsent: PropTypes.bool,
  fields: PropTypes.object.isRequired,
  sentReferrals: PropTypes.array,
  isNHConsentProvider: PropTypes.bool,
};

PaperAndVerbalConsentSection.defaultProps = {
  hasPlatformConsent: false,
  sentReferrals: [],
  isNHConsentProvider: false,
};

export default PaperAndVerbalConsentSection;
